import React from "react";
import AppRoute from "./common/AppRoute";
import { ThemeProvider } from "@mui/material";
import LightTheme from "./style/Theme";
import { DarkTheme } from "./style/Theme";

function App() {
  const [darkThemeStatus, setDarkThemeStatus] = React.useState(true);

  return (
    <ThemeProvider theme={darkThemeStatus ? DarkTheme : LightTheme}>
      <AppRoute
        darkThemeStatus={darkThemeStatus}
        setDarkThemeStatus={setDarkThemeStatus}
      />
    </ThemeProvider>
  );
}

export default App;
